import { Component } from "react"
import PropTypes from "prop-types"
import { capitalize } from "humanize-plus"
import classnames from "classnames"

import { getChannelSuggestions, getAppletFeedback } from "shared/lib/graphql"
import PlatformFeedbackCard from "./platform_feedback_card"
import styles from "./platform_feedback.module.scss"

export default class PlatformFeedbackPage extends Component {
  state = {
    suggestionCount: 0,
    feedbackList: [],
    order: "created_at_desc",
    startCursor: "",
    endCursor: "",
    hasPreviousPage: false,
    hasNextPage: false,
  }

  UNSAFE_componentWillMount() {
    this.pageQuery()
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.feedbackType === "applet_feedback" &&
      this.props.appletId !== prevProps.appletId
    )
      this.pageQuery()
  }

  pageQuery(queryOptions = {}) {
    // the cursor and firstOrLast boolean are entirely optional
    // without them the graph will return the list from the beginning (fresh page load)
    const { channel, appletId, contentType, feedbackType } = this.props

    if (feedbackType === "applet_feedback") {
      getAppletFeedback(
        appletId,
        this.state.order,
        queryOptions.cursor,
        queryOptions.isForwardSuggestionQuery
      ).then(data => {
        const {
          startCursor,
          endCursor,
          hasPreviousPage,
          hasNextPage,
        } = data.pageInfo
        this.setState({
          startCursor,
          endCursor,
          hasPreviousPage,
          hasNextPage,
          feedbackList: data.edges,
          suggestionCount: data.total_count,
        })
      })
    } else {
      getChannelSuggestions(
        channel,
        contentType === "connection" ? "applet" : contentType,
        this.state.order,
        queryOptions.cursor,
        queryOptions.isForwardSuggestionQuery
      ).then(data => {
        const {
          startCursor,
          endCursor,
          hasPreviousPage,
          hasNextPage,
        } = data.pageInfo
        this.setState({
          startCursor,
          endCursor,
          hasPreviousPage,
          hasNextPage,
          feedbackList: data.edges,
          suggestionCount: data.total_count,
        })
      })
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: document.querySelector(".platform-feedback-page-container").offsetHeight - 100,
      behaviour: "smooth",
    })
  }

  changePage = e => {
    if (e.target.innerText === "Next") {
      this.pageQuery({ cursor: this.state.endCursor })
    } else {
      this.pageQuery({
        cursor: this.state.startCursor,
        isForwardSuggestionQuery: false,
      })
    }
    this.scrollToTop()
  }

  filterList = e => {
    let order = e.target.value === "new" ? "created_at_desc" : "created_at_asc"
    this.setState({ order }, () => {
      this.pageQuery()
    })
  }

  render() {
    const { contentType, profileUrl, feedbackType } = this.props
    const { suggestionCount } = this.state
    return (
      <div
        className={classnames("platform-feedback-page-container", styles["platform-feedback-page-container"])}
      >
        <div className={styles["feedback-page-header"]}>
          <header className="page-header with-actions">
            {feedbackType === "applet_feedback" ? (
              <h3>{`All written feedback (${suggestionCount})`}</h3>
            ) : (
              <h1>
                {`${capitalize(contentType)} suggestions (${suggestionCount})`}
              </h1>
            )}
            <div className="header-actions">
              <select onChange={this.filterList}>
                <option value="new">Most recent</option>
                <option value="old">Oldest first</option>
              </select>
            </div>
          </header>
        </div>
        <div className="feedback-card-container">
          {this.state.feedbackList.map((feedback, ind) => {
            let node = feedback.node
            return (
              <PlatformFeedbackCard
                key={ind}
                id={node.id}
                like={node.like}
                createdAt={node.created_at}
                feedbackType={this.props.feedbackType}
                text={node.text}
                suggestionName={node.suggestion_name}
                userLogin={node.user.login}
                profileImgUrl={node.user.profile_image_url}
                channelInfo={node.context_channel}
                contextChannelPublished={node.context_channel_published}
                userProfileLink={`${profileUrl + node.user.login}`}
              />
            )
          })}
        </div>
        <div className={styles["feedback-nav-container"]}>
          <button
            className={styles["feedback-nav-button"]}
            onClick={this.changePage}
            disabled={!this.state.hasPreviousPage}
          >
            Previous
          </button>
          <button
            className={styles["feedback-nav-button"]}
            onClick={this.changePage}
            disabled={!this.state.hasNextPage}
          >
            Next
          </button>
        </div>
      </div>
    )
  }
}

PlatformFeedbackPage.propTypes = {
  channel: PropTypes.string,
  appletId: PropTypes.string,
  contentType: PropTypes.string,
  feedbackType: PropTypes.string,
  profileUrl: PropTypes.string,
}

PlatformFeedbackPage.defaultProps = {
  channel: "",
  appletId: "",
}
